import { render, staticRenderFns } from "./AuditTrailEntity.vue?vue&type=template&id=fad2c242"
import script from "./AuditTrailEntity.vue?vue&type=script&lang=js"
export * from "./AuditTrailEntity.vue?vue&type=script&lang=js"
import style0 from "./AuditTrailEntity.vue?vue&type=style&index=0&id=fad2c242&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports